import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { GeoGate } from './components/GeoGate';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { FullDetailPage } from './pages/FullDetailPage';
import { WashWaxPage } from './pages/WashWaxPage';
import { BasicWashPage } from './pages/BasicWashPage';
import { AboutPage } from './pages/AboutPage';
import { SpecialsPage } from './pages/SpecialsPage';
import { GalleryPage } from './pages/GalleryPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { ContactPage } from './pages/ContactPage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { HybridCeramicSprayPage } from './pages/HybridCeramicSprayPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
import { MobileDetailingPage } from './pages/MobileDetailingPage';
import { EngineBayDetailingPage } from './pages/EngineBayDetailingPage';
import { CityPage } from './pages/CityPage';
import { CityAliasRedirect } from './pages/CityAliasRedirect';
import { NotFoundPage } from './pages/NotFoundPage';
import { FaqPage } from './pages/FaqPage';
import { LocationsPage } from './pages/LocationsPage';
import { cities } from './data/cityData';
import { cityPath } from './utils/seo';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
      gtag('config', 'AW-349742034');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <GeoGate data-id="element-0" data-mp="3ubrhql7qei4i">
    <BrowserRouter data-id="element-1" data-mp="3uc9km0owfule">
      <Routes data-id="element-2" data-mp="3uevs60bsia3m">
        <Route element={<SiteLayout data-id="element-4" data-mp="d4e4tqw8j8vn" />} data-id="element-3" data-mp="3uf5lnxw1mze2">
          {/* Primary pages */}
          <Route path="/" element={<HomePage data-id="element-6" data-mp="d2bfl92wpjrz" />} data-id="element-5" data-mp="d3wbp34vdary" />
          <Route path="/services" element={<ServicesPage data-id="element-8" data-mp="86w3alkjrvxo" />} data-id="element-7" data-mp="851mnjgb6pze" />
          <Route path="/full-detail" element={<FullDetailPage data-id="element-10" data-mp="3gkv1zuywlvev" />} data-id="element-9" data-mp="83qgxe3az85n" />
          <Route path="/wash-wax" element={<WashWaxPage data-id="element-12" data-mp="3gj1ru5p30t24" />} data-id="element-11" data-mp="3gm61vjp8aj0p" />
          <Route path="/basic-wash" element={<BasicWashPage data-id="element-14" data-mp="3bnmedeuzkz68" />} data-id="element-13" data-mp="3bmti57tnls2c" />
          <Route path="/about" element={<AboutPage data-id="element-16" data-mp="3qaxuzv60z9d7" />} data-id="element-15" data-mp="3bk736n4foaa3" />
          <Route path="/specials" element={<SpecialsPage data-id="element-18" data-mp="3qdaj6q2dmfyp" />} data-id="element-17" data-mp="3qc94mbm5jbc8" />
          <Route path="/gallery" element={<GalleryPage data-id="element-20" data-mp="3ljg27ue5of3b" />} data-id="element-19" data-mp="3lkr5lt3ovktw" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-22" data-mp="2xuwsdafgju94" />} data-id="element-21" data-mp="3lj69w05n1vug" />
          <Route path="/contact" element={<ContactPage data-id="element-24" data-mp="2xtbzrqcpeldw" />} data-id="element-23" data-mp="2xu3ii0l7comr" />
          <Route path="/faq" element={<FaqPage data-id="element-26" data-mp="2swbuvirlbood" />} data-id="element-25" data-mp="2xsk3sef72ln3" />
          <Route path="/locations" element={<LocationsPage data-id="element-28" data-mp="2stpkzch88x2z" />} data-id="element-27" data-mp="2sv0p5del46um" />
          <Route path="/service-areas" element={<Navigate to="/locations" replace data-id="element-30" data-mp="18cznek02jfn0" />} data-id="element-29" data-mp="18e19djimhmji" />

          {/* Specialty service pages */}
          <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-32" data-mp="yflinhnicfaj" />} data-id="element-31" data-mp="1d5j8e2135d1u" />
          <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-34" data-mp="ydqulugxw728" />} data-id="element-33" data-mp="ygmuhoccl5tb" />
          <Route path="/services/hybrid-ceramic-spray" element={<HybridCeramicSprayPage data-id="element-36" data-mp="13clqny3x3s4a" />} data-id="element-35" data-mp="13dwt9ulmmttt" />
          <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-38" data-mp="1r268gdoc4jbz" />} data-id="element-37" data-mp="1r3r0nwn6fq6o" />
          <Route path="/services/mobile-detailing" element={<MobileDetailingPage data-id="element-40" data-mp="1w2kghvpxrta0" />} data-id="element-39" data-mp="1w3vlfyv4b72p" />
          <Route path="/services/engine-bay-detailing" element={<EngineBayDetailingPage data-id="element-42" data-mp="1i31e7jjt3c5m" />} data-id="element-41" data-mp="1i3uk6iaxxxmp" />

          {/* Retired URLs, redirected so existing links and rankings carry over. */}
          <Route path="/services/full-car-detail" element={<Navigate to="/full-detail" replace data-id="element-44" data-mp="6ncmkevlxoyh" />} data-id="element-43" data-mp="1m70pnnq8bks4" />
          <Route path="/services/ceramic-coating" element={<Navigate to="/services/hybrid-ceramic-spray" replace data-id="element-46" data-mp="ar278t95vme8" />} data-id="element-45" data-mp="6qs21it7100f" />

          {/* City landing pages */}
          <Route path="/service-areas/:slug" element={<CityPage data-id="element-48" data-mp="m6fbqndzipgu" />} data-id="element-47" data-mp="qxxcbac3io1a" />
          {/* Older city URL formats redirect to the canonical /service-areas/<city>. */}
          <Route path="/ventura-county/:slug" element={<CityAliasRedirect data-id="element-50" data-mp="h7vnggbx51lb" />} data-id="element-49" data-mp="h72o40fahed7" />
          {cities.map(city => <Route key={city.slug} path={`/mobile-detailing-${city.slug}`} element={<Navigate to={cityPath(city.slug)} replace data-id="element-52" data-mp="c6eoiqczvp7d" />} data-id="element-51" data-mp="c8izfs9b9oh5" />)}

          <Route path="*" element={<NotFoundPage data-id="element-54" data-mp="19v88gm2fl1ci" />} data-id="element-53" data-mp="19uotne82ut2p" />
        </Route>
      </Routes>
    </BrowserRouter>
    </GeoGate>;
}